export abstract class AbstractBridgeBase {
    public onMessageToClient?: (msg:BridgeOutputMessage) => void;

    protected sendMessageToClient(msg:BridgeOutputMessage) {
        if (this.onMessageToClient) {
            this.onMessageToClient(msg);
        }
    }

    public abstract supportsMessageType(msg:BridgeInputMessage): boolean;
    public abstract handleMessage(msg: BridgeInputMessage): Promise<any>;
    public abstract reset(): void;
}  

export class BridgeInputMessage {
    type?: string;
}

export class BridgeOutputMessage {
    [x: string]: any;
    type?: string;
}